"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * Shared "Forge" CTA button used across the ported marketing pages
 * (Elite, guia, cita, compra, bienvenido).
 *
 * Button + asChild + Next.js Link must live in a client component:
 * the Radix Slot element-cloning fails silently in Server Components
 * during production builds (same pattern as landing-cta-buttons.tsx).
 */
export function EliteCTAButton({
  href,
  children,
  size = "lg",
  className,
  external = false,
  showArrow = true,
}: {
  href: string;
  children: React.ReactNode;
  size?: "default" | "lg";
  className?: string;
  external?: boolean;
  showArrow?: boolean;
}) {
  return (
    <Button
      asChild
      size={size}
      className={cn(
        "cta-forge group h-14 px-8 text-base font-bold text-white",
        className,
      )}
    >
      <Link
        href={href}
        {...(external
          ? { target: "_blank", rel: "noopener noreferrer" }
          : {})}
      >
        {children}
        {showArrow && (
          <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
        )}
      </Link>
    </Button>
  );
}
